module.exports = __webpack_public_path__ + "static/media/ThumbUpThanksNew.683d075a.svg";